<script>
  import Footer from './components/Footer.svelte';
  import Header from './components/Header.svelte';
  import RequestForm from './components/RequestForm.svelte';

  // Initialize the Telegram Web App
  if (window.Telegram && window.Telegram.WebApp) {
    Telegram.WebApp.ready();
  }
</script>

<Header />

<div id="app">
  <main>
    <section class="section">
      <div class="container">
        <h3 class="is-3 label">Request the creation of a new Telegram Group</h3>
        <RequestForm />
      </div>
    </section>
  </main>
  <Footer />
</div>
